import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import "../../Ansible/./ansible.css";
/**
 * This is a dumb component that only recieves properties from a smart component.
 * Dumb components are usually functions and not classes.
 *
 * @param props the props given by the smart component.
 */

var Ansible = function Ansible(_ref) {
  var unsupported = _ref.unsupported,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["unsupported", "className"]);

  var ansibleLogoClass = classNames(className, 'Ansible', _defineProperty({}, "is-supported", !unsupported || unsupported === 0), _defineProperty({}, "is-unsupported", unsupported || unsupported === 1));
  var unsupportedSlash;
  var ariaLabels = {};

  if (unsupported) {
    var _ariaLabels;

    unsupportedSlash = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("rect", {
      x: "1245.1",
      y: "272.4",
      transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 3082.5815 -510.474)",
      className: "st0",
      width: "803.8",
      height: "221.5"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "-279.7",
      y: "904",
      transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 2450.9683 1014.3757)",
      className: "st1",
      width: "2590.2",
      height: "221.5"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "17.1",
      y: "1620.5",
      transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1734.4641 2744.1697)",
      className: "st0",
      width: "563.7",
      height: "221.5"
    }));
    ariaLabels = (_ariaLabels = {}, _defineProperty(_ariaLabels, 'disabled', 'disabled'), _defineProperty(_ariaLabels, 'aria-label', 'Does not have Ansible support'), _ariaLabels);
  } else {
    ariaLabels = _defineProperty({}, 'aria-label', 'Has Ansible support');
  }

  ;
  return /*#__PURE__*/React.createElement("i", _extends({
    className: ansibleLogoClass
  }, ariaLabels, props, {
    "widget-type": "InsightsAnsibleSupport"
  }), /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2032 2027.2",
    style: {
      enableBackground: 'new 0 0 2032 2027.2'
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2030.8,1014.8c0,559.2-453.3,1012.4-1012.4,1012.4C459.2,2027.2,5.9,1574,5.9,1014.8 C5.9,455.7,459.2,2.4,1018.3,2.4C1577.5,2.4,2030.8,455.7,2030.8,1014.8 M1035.4,620.9l262,646.6L901.7,955.8L1035.4,620.9 L1035.4,620.9z M1500.8,1416.5l-403-969.9c-11.5-28-34.5-42.8-62.4-42.8c-28,0-52.7,14.8-64.2,42.8L528.9,1510.4h151.3l175.1-438.6 l522.5,422.1c21,17,36.2,24.7,55.9,24.7c39.5,0,74-29.6,74-72.3C1507.7,1439.4,1505.3,1428.3,1500.8,1416.5L1500.8,1416.5z"
  }), unsupportedSlash));
};

export default Ansible;
Ansible.propTypes = {
  /**
   * Description that will generate MD docs file
   */
  unsupported: propTypes.oneOfType([propTypes.bool, propTypes.number]),
  className: propTypes.string
};